import { PageType } from '../../../page-edit-screen/page-type';

export interface ConfirmDialogViewModel {
  title?: string;
  description?: string;
  width?: string;
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  pageType?: PageType;
  pageId?: string;
}

export const defaultConfirmDialogViewModelValues: ConfirmDialogViewModel = {
  title: 'Are you sure?',
  description: '',
  cancelBtnLabel: 'No',
  confirmBtnLabel: 'Yes',
};
